export default "__VITE_ASSET__DlMOwX9N__"